import { render } from "./AdminHead.vue?vue&type=template&id=484e3f0a&scoped=true&ts=true"
import script from "./AdminHead.vue?vue&type=script&lang=ts"
export * from "./AdminHead.vue?vue&type=script&lang=ts"

import "./AdminHead.vue?vue&type=style&index=0&id=484e3f0a&lang=css"
import "./AdminHead.vue?vue&type=style&index=1&id=484e3f0a&scoped=true&lang=css"
import "./AdminHead.vue?vue&type=style&index=2&id=484e3f0a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484e3f0a"]])

export default __exports__